import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { ProductSummaryItem } from '@backbase/data-ang/arrangements';

@Component({
  selector: 'bn-beneficiary-account',
  templateUrl: 'beneficiary-account.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BeneficiaryAccountComponent {
  /**
   * Own account item
   */
  @Input()
  set account(item: ProductSummaryItem) {
    this._account = item;
    if (item) {
      this.accountNumber = item.BBAN || item.number || '';
      this.balances = this.getBalance(item);
    }
  }
  get account() {
    return this._account;
  }
  private _account!: ProductSummaryItem;

  getBalance(item: ProductSummaryItem): { currency: string | undefined, amount: number | undefined }[]{
    const creditCardItem = item.product?.productKind?.id === 4;
    if (creditCardItem){
      const balances = [];
      const localAvailableBalance = item.additions?.localAvailableBalance;
      const foreignAvailableBalance = item.additions?.foreignAvailableBalance;

      if (localAvailableBalance && +localAvailableBalance !== -1 ){
        balances.push({
          currency: item.additions?.localCurrencyCode,
          amount: +localAvailableBalance
        });
      }

      if (foreignAvailableBalance && +foreignAvailableBalance !== -1 ){
        balances.push({
          currency: item.additions?.foreignCurrencyCode,
          amount: +foreignAvailableBalance
        });
      }
     return balances;
    }

    return [{
      currency: item.currency,
      amount: item?.availableBalance || item?.bookedBalance
    }];
  }

  accountNumber?: string;
  balances?: { currency: string | undefined, amount: number | undefined }[];
}
